import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message, Tag} from "antd";
import {FileUploadUtils} from "../../../utils/FileUploadUtils";
import {FormUtils} from "../../../utils/FormUtils";
import {LockOutlined} from "@ant-design/icons";
import sha256 from 'crypto-js/sha256'

const FORM = [
    {
        name: "用户角色",
        key: "role",
        type: "select",
    },
    {
        name: "用户名",
        key: "username",
        type: "input",
    },
    {
        name: "新密码",
        key: "password",
        type: "password",
        extra: <Tag color="green"><LockOutlined/> 密码将经过传输与存储加密</Tag>
    },
]

const UserEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const guid = searchParams.get("guid")

    const [initFormData, setInitFormData] = useState({})
    const [initFiles, setInitFiles] = useState({})
    const [roles, setRoles] = useState([])

    let changedForms = {}
    let changedFiles = {}

    useEffect(() => {
        if (guid) {
            ApiService.admin.system.user.get(guid)
                .onSuccess(data => {
                    const initFormData = data
                    const initFiles = {}
                    if (data.imageUrl) {
                        initFiles["imageUrl"] = [FileUploadUtils.toInitFileMap(0, data.imageUrl)]
                    }

                    setInitFormData(initFormData)
                    setInitFiles(initFiles)
                })
        }

        ApiService.admin.system.user.roles()
            .onSuccess(data => {
                setRoles(data)
            })
    }, [guid]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const handleFileChange = (change) => {
        changedFiles = {
            ...changedFiles,
            ...change
        }
    }

    const createOrUpdate = (form) => {
        const formToSubmit = {...form}
        if (formToSubmit.hasOwnProperty('password')) {
            let p = formToSubmit.password
            if (p === null || p === undefined || p.length === 0) {
                throw Error("密码不能为空")
            }
            p = sha256(p).toString()
            formToSubmit.password = p
        }
        if (guid) {
            return ApiService.admin.system.user.update(formToSubmit)
        } else {
            if (!form.hasOwnProperty('password')) {
                throw Error("密码不能为空")
            }
            return ApiService.admin.system.user.create(formToSubmit)
        }
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, changedFiles, true, false, {guid: guid})
            createOrUpdate(form)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"编辑用户信息"}
                formStruct={FORM}
                initValues={initFormData}
                initFiles={initFiles}
                selectOptions={{
                    role: roles
                }}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
                onFileChange={handleFileChange}
            />
        </>
    )
}

export default UserEditPage